<template>
  <VanPopup
    v-model="show"
    round
    safe-area-inset-bottom
    position="bottom"
    overlay-class="custom-van-popup-overlay"
    class="custom-van-popup"
    @close="onCancel"
  >
    <VanPicker
      ref="datetimePicker"
      :default-index="defaultIndex"
      title="选择用车时间"
      show-toolbar
      value-key="label"
      :item-height="50"
      :columns="columns"
      :visible-item-count="5"
      class="custom-van-picker2"
      confirm-button-text="确定"
      @confirm="onConfirm"
      @cancel="onCancel"
    >
    </VanPicker>
  </VanPopup>
</template>

<script>
export default {
  name: "DatetimePicker",
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        // 重新设置默认选中项
        const picker = this.$refs.datetimePicker;
        if (picker) {
          picker.setIndexes([this.defaultIndex]);
        }
      }
    },
  },
  methods: {
    onConfirm(value, indexs) {
      const [index, index2] = indexs;
      const item = this.columns[index];
      const item2 = item.children[index2];
      this.$emit("confirm", `${item.value}__${item2.value}`);
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/custom-vant.scss";
</style>
